import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'components';
import { Constants, Globals, checkPermission } from 'utils';
import { PriceMeterService } from 'services';

interface Props {
	onClose: any;
	dispatch: any;
}

class ModalPriceMeter extends React.Component<Props> {

	state = {
		form: {
			price: 0,
			price_corporate: 0,
			minimum: 0
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await PriceMeterService.admin.get();
		if (res.price_meter) {
			this.setState({
				form: {
					price: res.price_meter?.price || 0,
					price_corporate: res.price_meter?.price_corporate || 0,
					minimum: res.price_meter?.minimum || 0
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (checkPermission(Constants.MODULES.EXCHANGE,'write')) {
			await PriceMeterService.admin.update({
				price: this.state.form.price,
				price_corporate: this.state.form.price_corporate,
				minimum: this.state.form.minimum
			});
			Globals.showSuccess("Se ha actualizado el precio por m2");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-exchange">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-6">
							<Input
								disabled={ !checkPermission(Constants.MODULES.PRICE_METER,'write') }
								color="white"
								value={ this.state.form.price }
								name="price" 
								label="Precio"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								disabled={ !checkPermission(Constants.MODULES.PRICE_METER,'write') }
								color="white"
								value={ this.state.form.price_corporate }
								name="price_corporate" 
								label="Precio Corporativo"
								onChange={ this.change } />
						</div>
					</div>
					<div className="text-center" style={{ marginTop: '35px' }}>
						<Input
							disabled={ !checkPermission(Constants.MODULES.PRICE_METER,'write') }
							color="white"
							value={ this.state.form.minimum }
							name="minimum" 
							label="Cantidad mínima de m2"
							onChange={ this.change } />
					</div>
					{
						checkPermission(Constants.MODULES.PRICE_METER,'write') && (
							<div className="text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						)
					}
				</form>
			</div>
		)
	}
}

export default ModalPriceMeter;